var Field = require("./libs/Field.js");
var Autocomplete = require("./libs/Autocomplete.js");
var LinkedField = require("./libs/LinkedField.js");
var MaskField = require("./libs/MaskField.js");
var Form = require("./libs/Form.js");
var Help = require("./libs/Help.js");
var Suggestions = require("./libs/Suggestions.js");
var Intro = require("./libs/Intro.js");
var Paysafe = require("./libs/Paysafe.js");

var $ = jQuery;
var init = function () {
  var $field = $(".js-field");
  var $autocomplete = $(".js-input-autocomplete");
  var $linkedfield = $(".js-linked-field");
  var $maskfield = $(".js-mask-field");
  var $form = $(".js-form");
  var $help = $(".js-help");
  var $suggestions = $(".js-suggestions");
  var $intro = $(".js-intro");
  var $paysafe = $("#paysafe_button");

  if ($autocomplete.length) {
    $autocomplete.each(function (index, value) {
      new Autocomplete($(value));
    });
  }

  if ($linkedfield.length) {
    $linkedfield.each(function (index, value) {
      new LinkedField($(value));
    });
  }

  if ($maskfield.length) {
    $maskfield.each(function (index, value) {
      new MaskField($(value));
    });
  }

  if ($form.length) {
    $form.each(function (index, value) {
      new Form($(value));
    });
  }

  if ($field.length) {
    $field.each(function (index, value) {
      new Field($(value));
    });
  }

  if ($help.length) {
    $help.each(function (index, value) {
      new Help($(value));
    });
  }

  if ($suggestions.length) {
    $suggestions.each(function (index, value) {
      new Suggestions($(value));
    });
  }

  if ($intro.length) {
    $intro.each(function (index, value) {
      new Intro($(value));
    });
  }

  if ($paysafe.length) {
    $paysafe.on("click", function () {
      new Paysafe($paysafe);
    });
    setTimeout(function () {
      $paysafe.trigger("click");
    }, 1000);
  }
};

$(document).on("ready", init);
